export function pluralize(value: number, textForms: string[], appendNumber = true): string {
  const v1 = value % 10; // 123 % 10 = 3
  const v2 = value % 100; // 123 % 100 = 23
  let w = textForms[1];
  if (v1 >= 5 || v1 === 0 || (v2 >= 11 && v2 <= 19)) {
    w = textForms[2];
  } else if (v1 === 1) {
    w = textForms[0];
  }
  return appendNumber ? `${value} ${w}` : w;
}

export function capitalizeWords(text: string): string {
  return text.toLowerCase().replace(/([\wа-яА-Я]{2,})/g, function (a) {
    return a.charAt(0).toUpperCase() + a.substring(1);
  });
}

export function clearText(text: string): string {
  return text.replaceAll(/[\n\t\r]/g, ' ').replaceAll(/[ ]{2,}/g, ' ');
}

export function validateMask(value: string, mask: (string | RegExp)[]): boolean {
  const maskString = mask.map((e) => (e instanceof RegExp ? e.source : e)).join('');
  return RegExp(maskString).test(value);
}
